import React from "react";
import PropTypes from "prop-types";
import styles from "./StockReportItem.module.css";

export function StockReportItem({
  sku,
  bin,
  title,
  salesByDate = [],
  average,
  onHand,
  available,
}) {
  return (
    <div className={styles.row}>
      <span className={`${styles.cell} ${styles.sku}`}>{sku}</span>
      <span className={`${styles.cell} ${styles.bin}`}>{bin}</span>
      <span className={`${styles.cell} ${styles.title}`}>{title}</span>

      <div className={styles.salesGroup}>
        {salesByDate.map(({ date, quantity }) => (
          <span
            key={`${date}-${quantity}`}
            className={`${styles.cell} ${styles.salesCell}`}
            title={date}
          >
            {quantity}
          </span>
        ))}
      </div>

      <span className={`${styles.cell} ${styles.metric}`}>{average}</span>
      <span className={`${styles.cell} ${styles.metric}`}>{onHand}</span>
      <span className={`${styles.cell} ${styles.metric}`}>{available}</span>
    </div>
  );
}

StockReportItem.propTypes = {
  sku: PropTypes.string.isRequired,
  bin: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  salesByDate: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      quantity: PropTypes.number.isRequired,
    })
  ),
  average: PropTypes.string.isRequired,
  onHand: PropTypes.string.isRequired,
  available: PropTypes.string.isRequired,
};
